import { combineReducers } from 'redux';
import movieReducer from './movieReducer';
import genresIdReducer from './genresIdReducer';
import toggleNavReducer from './toggleNavReducer';
import tvReducer from './tvReducers';
import changeTypeReducer from './changeTypeReducer';
import multiSearchReducer from './multiSearchReducer';
import titileInfoReducer from './titileInfoReducer';
import personInfoReducer from './personInfoReducer';
import searchPageReducer from './searchPageReducer';
import authReducer from './auth';

const rootReducer = combineReducers({
  movieReducer,
  genresIdReducer,
  toggleNavReducer,
  tvReducer,
  changeTypeReducer,
  multiSearchReducer,
  titileInfoReducer,
  personInfoReducer,
  searchPageReducer,
  authReducer
});

export default rootReducer;
